export default [
  // 系统管理路由（超级管理员可见）
  {
    path: "user",
    name: "des_tes_user",
    meta: {
      title: "用户管理",
      breadcrumb: ["系统管理", "用户管理"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/system/UserManage.vue"
      ),
  },
  {
    path: "role",
    name: "des_tes_role",
    meta: {
      title: "角色管理",
      breadcrumb: ["系统管理", "角色管理"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/system/RoleManage.vue"
      ),
  },
  {
    path: "menu",
    name: "des_tes_menu",
    meta: {
      title: "菜单管理",
      breadcrumb: ["系统管理", "菜单管理"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/system/MenuManage.vue"
      ),
  },
  // 地图监控
  {
    path: "/des_tes/project/map",
    name: "des_tes_map",
    meta: {
      title: "地图监控",
      breadcrumb: ["数据大屏", "地图监控"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/mw_views/project/map.vue"
      ),
  },
  // 3D 组态
  {
    path: "/des_tes/project/3d-editor",
    name: "des_tes_3dEditor",
    meta: {
      title: "3D 组态",
      breadcrumb: ["项目管理", "3D 组态"],
    },
    component: () =>
      import(
        /*webpackChunkName: "3DEditor" */ "@/views/mw_views/project/3d-editor.vue"
      ),
  },
  // 3D 查看
  {
    path: "/des_tes/project/3d-viewer",
    name: "des_tes_3dViewer",
    meta: {
      title: "3D 查看",
      breadcrumb: ["项目管理", "3D 查看"],
    },
    component: () =>
      import(
        /*webpackChunkName: "3DViewer" */ "@/views/mw_views/project/3d-viewer.vue"
      ),
  },
  // 集中监控
  {
    path: "/des_tes/project/centermonitor",
    name: "des_tes_centermonitor",
    meta: {
      title: "集中监控",
      breadcrumb: ["数据大屏", "集中监控"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/mw_views/project/centermonitor.vue"
      ),
  },
  // 工作台
  {
    path: "/des_tes/project/workbench",
    name: "des_tes_workbench",
    meta: {
      title: "工作台",
      breadcrumb: ["项目中心", "工作台"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/mw_views/project/workbench.vue"
      ),
  },
  // 分析页
  {
    path: "/des_tes/project/analysis",
    name: "des_tes_analysis",
    meta: {
      title: "分析页",
      breadcrumb: ["项目中心", "分析页"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/tes_views/project/analysis.vue"
      ),
  },
  // 实时监控
  {
    path: "/des_tes/project/realmonitor",
    name: "des_tes_realmonitor",
    meta: {
      title: "实时监控",
      breadcrumb: ["数据分析", "实时监控"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/mw_views/project/realmonitor.vue"
      ),
  },
  // 历史报表
  {
    path: "/des_tes/project/historyreport",
    name: "des_tes_historyreport",
    meta: {
      title: "历史报表",
      breadcrumb: ["报表中心", "历史报表"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/mw_views/project/historyreport.vue"
      ),
  },
  // 个人中心
  {
    path: "/des_tes/project/personal",
    name: "des_tes_personal",
    meta: {
      title: "个人中心",
      breadcrumb: ["个人中心", "个人中心"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/mw_views/project/personal.vue"
      ),
  },
  // 消息中心
  {
    path: "/des_tes/project/message",
    name: "des_tes_message",
    meta: {
      title: "消息中心",
      breadcrumb: ["消息中心", "消息中心"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/mw_views/project/message.vue"
      ),
  },
  // 推送管理
  {
    path: "/des_tes/project/pushmanage",
    name: "des_tes_pushmanage",
    meta: {
      title: "推送管理",
      breadcrumb: ["消息中心", "推送管理"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/mw_views/project/pushmanage.vue"
      ),
  },
  // 活跃报警
  {
    path: "/des_tes/project/activealarm",
    name: "des_tes_activealarm",
    meta: {
      title: "活跃报警",
      breadcrumb: ["报警管理", "活跃报警 "],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/mw_views/project/activealarm.vue"
      ),
  },
  // 历史报警
  {
    path: "/des_tes/project/historyalarm",
    name: "des_tes_historyalarm",
    meta: {
      title: "历史报警",
      breadcrumb: ["报警管理", "历史报警 "],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/mw_views/project/historyalarm.vue"
      ),
  },
  // 视频管理
  {
    path: "/des_tes/project/video",
    name: "des_tes_video",
    meta: {
      title: "视频管理",
      breadcrumb: ["视频管理", "视频管理"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/mw_views/project/video.vue"
      ),
  },
  // 资产总览
  {
    path: "/des_tes/project/assetoverview",
    name: "des_tes_assetoverview",
    meta: {
      title: "资产总览",
      breadcrumb: ["资产管理", "资产总览 "],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/mw_views/project/assetoverview.vue"
      ),
  },
  // 设备管理
  {
    path: "/des_tes/project/devicemanage",
    name: "des_tes_devicemanage",
    meta: {
      title: "设备管理",
      breadcrumb: ["资产管理", "设备管理"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/mw_views/project/devicemanage.vue"
      ),
  },
  // 设备档案
  {
    path: "/des_tes/project/archives",
    name: "des_tes_archives",
    meta: {
      title: "设备档案",
      breadcrumb: ["资产管理", "设备档案"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/mw_views/project/archives.vue"
      ),
  },
  // 运维总览
  {
    path: "/des_tes/project/overview",
    name: "des_tes_overview",
    meta: {
      title: "运维总览",
      breadcrumb: ["运维服务", "运维总览"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/mw_views/project/overview.vue"
      ),
  },
  // 人员管理 -> 用户管理
  {
    path: "/des_tes/project/usermanage",
    name: "des_tes_usermanage",
    meta: {
      title: "用户管理",
      breadcrumb: ["人员管理", "用户管理"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/system/UserManage.vue"
      ),
  },
  // 人员管理 -> 角色管理
  {
    path: "/des_tes/project/role",
    name: "des_tes_role_redirect",
    meta: {
      title: "角色管理 ",
      breadcrumb: ["人员管理", "角色管理"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/system/RoleManage.vue"
      ),
  },
  // 人员管理 -> 权限管理
  {
    path: "/des_tes/project/permission",
    name: "des_tes_permission",
    meta: {
      title: "权限管理",
      breadcrumb: ["人员管理 ", "权限管理"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/system/MenuManage.vue"
      ),
  },
  // 数据源管理
  {
    path: "/des_tes/project/DataSource",
    name: "des_tes_DataSource",
    meta: {
      title: "数据源管理",
      breadcrumb: ["变量管理", "数据源管理"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/mw_views/project/DataSource.vue"
      ),
  },
  // 变量配置
  {
    path: "/des_tes/project/VariableManager",
    name: "des_tes_VariableManager",
    meta: {
      title: "变量配置",
      breadcrumb: ["变量管理", "变量配置"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/mw_views/project/VariableManager.vue"
      ),
  },
  // 操作日志
  {
    path: "/des_tes/project/log",
    name: "des_tes_log",
    meta: {
      title: "操作日志",
      breadcrumb: ["操作日志", "操作日志"],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ "@/views/mw_views/project/log.vue"
      ),
  },
];
